import { isBrowser } from './browser';
import type { WithdrawRequestSource } from './track';

const WITHDRAW_BANNER_SOURCE_KEY = 'withdraw_banner_source';

export const setWithdrawBannerSource = (source: WithdrawRequestSource) => {
  if (isBrowser()) {
    sessionStorage.setItem(WITHDRAW_BANNER_SOURCE_KEY, source);
  }
};

export const consumeWithdrawBannerSource = (): WithdrawRequestSource | null => {
  if (!isBrowser()) return null;
  const source = sessionStorage.getItem(WITHDRAW_BANNER_SOURCE_KEY) as WithdrawRequestSource | null;
  if (source) sessionStorage.removeItem(WITHDRAW_BANNER_SOURCE_KEY);
  return source;
};

export const peekWithdrawBannerSource = (): WithdrawRequestSource | null => {
  if (!isBrowser()) return null;
  return sessionStorage.getItem(WITHDRAW_BANNER_SOURCE_KEY) as WithdrawRequestSource | null;
};

const DEPOSIT_BANNER_SOURCE_KEY = 'deposit_banner_source';

export const setDepositBannerSource = (source: WithdrawRequestSource) => {
  if (isBrowser()) {
    sessionStorage.setItem(DEPOSIT_BANNER_SOURCE_KEY, source);
  }
};

export const consumeDepositBannerSource = (): WithdrawRequestSource | null => {
  if (!isBrowser()) return null;
  const source = sessionStorage.getItem(DEPOSIT_BANNER_SOURCE_KEY) as WithdrawRequestSource | null;
  if (source) sessionStorage.removeItem(DEPOSIT_BANNER_SOURCE_KEY);
  return source;
};

export const peekDepositBannerSource = (): WithdrawRequestSource | null => {
  if (!isBrowser()) return null;
  return sessionStorage.getItem(DEPOSIT_BANNER_SOURCE_KEY) as WithdrawRequestSource | null;
};
